import React, { useState, useEffect } from "react";
import { sendApplication, uploadFile } from "../../../api";
import NavBar from "../components/Navbar";
import { useParams } from 'react-router-dom';
import { getAllJobs } from '../../../api'
import "./styles.css";
import axios from 'axios'

const ParticularJobResume = () => {
  const [jobs, setJobs] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const { jobId } = useParams()
  const [file, setFile] = useState(null)

  useEffect(async () => {
    const response = await getAllJobs();
    console.log("Res:", response.data.jobs)
    setJobs(response.data.jobs)
    setIsLoading(false)
  }, [])

  const jobName = jobs.filter(job => job._id === jobId)
  console.log("Job Name:", jobName, "Job ID:", jobId)

  const initialData = {
    jobId,
    name: "",
    email: "",
    contactNo: "",
    comments: "",
    resume: null,
    isWithoutAttachment: false,
  };
  const [formData, setFormData] = useState(initialData);

  const uploadFile = async (resume) => {
    const formDataFinal = new FormData()
    formDataFinal.append('file', resume)
    formDataFinal.append('upload_preset', 'ml_default')
    formDataFinal.append('api_key', '375547884857951')

    return axios.post('https://api.cloudinary.com/v1_1/instaclone29/image/upload',
      formDataFinal,
      { headers: { 'X-Requested-With': 'XMLHttpRequest' } }
    )
      .then(uploadRes => uploadRes)
      .then(data => data)
      .catch(err => {
        console.log(err)
        return err.message
      })

  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const response = await uploadFile(file)
    console.log("Cloudinary Response:", response)

    formData.resume = response.data.url
    formData.cloudinary_id = response.data.asset_id
    console.log(formData);
    const {data} =  await sendApplication(formData);
    console.log("Final Data:", data)
    setFormData(initialData);
  };

  const handleChange = async (event) => {
    const { name } = event.target;
    if(name === 'resume')
    {
      console.log(event.target.value)
      // const { data } = await uploadFile({ resume: event.target.files});
      // console.log(data);
    }
    setFormData((prevFormData) => {
      return {
        ...prevFormData,
        [name]:  (name === 'isWithoutAttachment')? event.target.checked : event.target.value
      };
    });
  };

  return (
    <>
      <NavBar />
      {isLoading && <div>Loading...</div>}
      {!isLoading && (
        <div className="container">
          <div className="formBox">
            <h2>Submitting application for</h2>
            <h3>{jobName[0].Name}</h3>
            <form className="jobResumeForm" onSubmit={handleSubmit}>
              <div className="formItem">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="formFlex">
                <div className="formItem contact">
                  <label htmlFor="contactNo">Contact Number</label>
                  <input
                    type="tel"
                    pattern="^\d{10}$"
                    name="contactNo"
                    value={formData.contactNo}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="formItem email">
                  <label htmlFor="email">Mail-id</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <div className="formItem">
                <label htmlFor="comments">Comments</label>
                <textarea
                  name="comments"
                  id=""
                  cols="30"
                  rows="10"
                  value={formData.comments}
                  onChange={handleChange}
                />
              </div>
              <div className="resumeForm">
                <label htmlFor="resume">Attach Resume: </label>
                <input type="file" name="resume" onChange={(e) => setFile(e.target.files[0])}  />
              </div>
              <div className="checkbox">
                <input
                  type="checkbox"
                  name="isWithoutAttachment"
                  style={{ display: "inline-block" }}
                  checked={formData.isWithoutAttachment}
                  onChange={handleChange}
                />
                <label htmlFor="isResume" style={{ fontSize: "14px" }}>
                  Don't have you resume ready? Continue without attachment
                </label>
              </div>
              <button type="submit" className="submitbtn">
                SUBMIT
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default ParticularJobResume;
